export default __webpack_public_path__ + "static/media/Aarush_Tanwar_RESUME.e4171aac.png";